"use client";
import authImage from "@/assets/auth/auth-img.png";
import authElement from "@/assets/auth/auth-left-footer.png";
import authElement2 from "@/assets/auth/auth-title-blur.png";
import { useSettings } from "@/context/settingsContext";
import { useT } from "@/context/TranslationContext";
import ApiPath from "@/network/api/apiPath";
import NetworkService from "@/network/service/networkService";
import { encrypt } from "@/utils/crypto";
import { getSettingValue } from "@/utils/utils";
import { Icon } from "@iconify/react";
import Image from "next/image";
import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import { useState } from "react";
import { toast } from "react-toastify";
import LanguageDropdown from "../dashboard/UserDropdown/LanguageDropdown";
const ForgetPassword = () => {
  const network = new NetworkService();
  const [email, setEmail] = useState("");
  const pathname = usePathname();
  const router = useRouter();
  const encryptedEmail = email ? encrypt(email) : "";
  const { settings } = useSettings();
  const siteLogo = getSettingValue(settings, "site_logo");
  const siteLogoHeight = getSettingValue(settings, "site_logo_height");
  const t = useT();

  const handleForgetPasswordSubmit = async (e) => {
    e.preventDefault();
    try {
      const requestBody = { email: email };
      const res = await network.post(ApiPath.forgetPassword, requestBody);
      if (res.status === "completed") {
        toast.success(res.data.message);
        router.push(
          `/auth/login/forgot-password-otp?email=${encodeURIComponent(
            encryptedEmail,
          )}`,
        );
      }
    } finally {
    }
  };

  return (
    <div className="auth-full-page h-screen overflow-hidden">
      <div className="auth-page flex lg:flex-row flex-col h-full">
        <div className="left w-full lg:w-1/2">
          <div className="auth-left-content h-full flex flex-col items-center relative">
            <div className="max-w-full sm:max-w-[460px] xl:max-w-[560px] 2xl:max-w-[640px] 3xl:max-w-[721px] h-screen border-l-0 sm:border-l border-r-0 sm:border-r border-user-input-border relative">
              <div className="absolute top-3 right-3">
                <LanguageDropdown authpage={true} />
              </div>
              <div className="auth-left-content-inner">
                <Link
                  href="/"
                  className={`block logo h-[${siteLogoHeight}px] w-auto mb-8 sm:mb-[40px] lg:mb-[60px] 2xl:mb-[90px]`}
                >
                  {siteLogo ? (
                    <Image
                      src={siteLogo}
                      height={40}
                      width={100}
                      alt="Logo"
                      unoptimized
                      className="h-full w-auto"
                    />
                  ) : (
                    <div className="h-[30px] w-[100px] bg-gray-100 animate-pulse rounded"></div>
                  )}
                </Link>
                <div className="title-and-button px-0 2xl:px-[70px] relative mb-8 sm:mb-[40px] lg:mb-[50px]">
                  <div className="text-center">
                    <h2 className="text-[24px] sm:text-[30px] font-bold text-user-text mb-3 text-center">
                      {t("authPages.resetYourPasswordTitle")}
                    </h2>
                    <p className="text-[14px] text-user-paragraph font-semibold text-center">
                      {t("authPages.resetYourPasswordSubTitle")}
                    </p>
                  </div>
                  <div className="bg-blur top-[-110px] absolute left-1/2 -translate-x-1/2 z-[-1]">
                    <div className="w-[541px] h-[282px]">
                      <Image
                        src={authElement2}
                        width={1000}
                        height={1000}
                        alt="Background Blur"
                        className="w-[541px] h-[282px]"
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full">
                  <form onSubmit={handleForgetPasswordSubmit}>
                    <div className="grid grid-cols-12 gap-3.5 sm:gap-5">
                      <div className="col-span-12">
                        <label htmlFor="email" className="user-label">
                          {t("authPages.email")}{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <div className="relative">
                          <input
                            type="email"
                            id="email"
                            name="email"
                            className="user-input peer"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          <div className="icon absolute rtl:left-4 ltr:right-4 top-1/2 -translate-y-1/2 text-[rgba(45,45,45,0.44)] peer-focus:text-[rgba(116,69,255,0.60)]">
                            <Icon
                              icon="basil:envelope-solid"
                              width="20"
                              height="20"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="group primary-button w-full mt-5 sm:mt-[30px] lg:mt-[40px]"
                    >
                      <span className="primary-button-hover-effect"></span>
                      <span className="primary-button-text">
                        {t("authPages.resetPassword")}
                      </span>
                    </button>
                  </form>
                </div>
                <div className="path-switch mt-[40px] lg:mt-[60px]">
                  <p className="text-center text-[13px] font-semibold text-user-paragraph">
                    {t("authPages.back")}?{" "}
                    <Link href="/auth/login" className="text-user-primary">
                      {t("authPages.signIn")}
                    </Link>
                  </p>
                </div>
              </div>
            </div>
            <div className="absolute bottom-0 rtl:right-0 ltr:left-0 z-[-1] w-full">
              <Image
                src={authElement}
                width={1000}
                height={1000}
                alt="Auth Element"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
        <div className="right w-1/2 h-screen fixed rtl:left-0 ltr:right-0 top-0 lg:block hidden">
          <div className="auth-image w-full h-full">
            <Image
              src={authImage}
              width={1000}
              height={1000}
              alt="Auth Image"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
